import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';
import { ClaimType } from '../enums';
import { map } from 'rxjs/operators';

@Injectable()
export class RoleService implements NbRoleProvider {

  constructor(private authService: NbAuthService) {
  }

  getRole(): Observable<string> {
    return this.authService.onTokenChange()
      .pipe(
        map((token: NbAuthJWTToken) => {
          return token.isValid() ? token.getPayload()[ClaimType.Role] : 'Guest';
        }),
      );
  }
}
